/**
 * EllipsisTooltip
 * @author Zongqi Wei
 */
import { Tooltip } from 'antd';
import React from 'react';

import areEqual from '@utils/reactUtils/areEqual';

import styles from './index.less';

const getPopupContainer = () => document.body;

export default class EllipsisTooltip extends React.PureComponent {
  static defaultProps = {
    tooltipText: '',
    className: '',
    children: '',
    getPopupContainer,
  };

  timer = null;

  state = {
    showEllipsis: false,
  };

  constructor(props) {
    super(props);
    this.spanRef = React.createRef();
  }

  async componentDidMount() {
    await this.computeEllipsis();
  }

  async componentDidUpdate(prevProps) {
    const { children: prevChildren, ...prevRest } = prevProps;
    const { children, ...rest } = this.props;
    if (!areEqual(prevRest, rest)) {
      await this.computeEllipsis();
    }
  }

  computeEllipsis = () =>
    new Promise((resolve) => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        const node = this.spanRef.current;
        const { showEllipsis } = this.state;
        if (!node) {
          return;
        }
        const currentShowEllipsis = node.scrollWidth > node.clientWidth;
        if (showEllipsis !== currentShowEllipsis) {
          this.setState(
            () => ({
              showEllipsis: currentShowEllipsis,
            }),
            () => {
              resolve();
            },
          );
        }
      }, 0);
    });

  render() {
    const {
      text,
      tooltipText,
      className,
      children,
      getPopupContainer: getPopupContainerFromProps,
      dataIndex,
      style,
    } = this.props;
    const { showEllipsis } = this.state;
    const classes = `${styles.ellipsisTooltipWrapper} ${
      dataIndex && styles.dimensionNameText
    } ${className}`;
    if (showEllipsis) {
      return (
        <Tooltip title={tooltipText || text} getPopupContainer={getPopupContainerFromProps}>
          <span style={{ ...(style ?? {}) }} className={classes} ref={this.spanRef}>
            {children || text}
          </span>
        </Tooltip>
      );
    }

    return (
      <span style={{ ...(style ?? {}) }} className={classes} ref={this.spanRef}>
        {children || text}
      </span>
    );
  }
}
